import { getColor, getSize, getWeight } from "views/resources/theme";
import styled from "styled-components";

export const Wrapper = styled.div`
	font-family: "Montserrat", sans-serif;
	display: flex;
	width: 643px;
	min-width: 500px;
	position: relative;
	margin: ${(props) => (props.abriged ? "0 auto 1.5rem" : "1.5rem auto")};
	padding: 0;
	border-radius: ${getSize("s")};
	border-top-right-radius: ${(props) =>
		props.abriged ? `${getSize("s")}` : 0};
	box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
	background-color: ${getColor("bg")};
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
`;

export const TopView = styled.div`
	display: flex;
	flex-direction: ${(props) => (props.abriged ? "row" : "column")};
	position: relative;

	align-items: center;
	border-right: 2px dashed ${getColor("secondaryDark")};
	padding: ${(props) => (props.abriged ? "1rem 0.5rem" : 0)};
	/* padding-top: ${(props) => (props.abriged ? "1rem" : "20%")}; */
	min-width: 280px;
	width: 100%;
	padding-left: 24px;
	padding-bottom: 24px;

	.date__container {
		width: 100%;
		font-size: 12px;
	}
	.link-meet-button-text {
		font-size: 12px;
		color: ${getColor("secondaryDark")};
	}
	.officeName {
		display: inline-block;
		margin: 0;
		/* margin-left: ${(props) => (props.abriged ? "1.5rem" : 0)};
		margin-right: ${(props) => (props.abriged ? "1rem" : 0)};
		margin-bottom: ${(props) => (props.abriged ? 0 : "1rem")}; */
		font-size: 1rem;
		font-weight: ${getWeight("semibold")};
		color: ${getColor("fg")};
		text-align: left;
		width: 100%;
	}

	.noticeText {
		font-family: Montserrat;
		font-size: 1.6rem;
		font-weight: 500;
		line-height: 1.5rem;
		letter-spacing: 0;
		text-align: center;
		color: #0050b3;
	}

	&::before,
	&::after {
		display: block;
		position: absolute;
		margin: 0;
		padding: 0;

		right: -17px;
		background-color: ${(props) => (props.abriged ? "#F4F9FF" : "#fff")};
		content: "";
		width: 30px;
		height: 30px;
		border-radius: 50%;
		z-index: 100;
	}
	&::before {
		top: -14px;
		border-top-right-radius: 110px;
		border-bottom-right-radius: 110px;
		box-shadow: inset -2px 0px 0px rgb(0 0 0 / 20%);
		transform: rotate(90deg);
	}
	&::after {
		bottom: -14px;
		border-top-left-radius: 110px;
		border-bottom-left-radius: 110px;
		box-shadow: inset 2px 0px 0px rgb(0 0 0 / 20%);
		transform: rotate(90deg);
	}
	button {
		width: 80%;
	}
`;

export const HeaderOfficeInfo = styled.div`
	display: flex;
	align-items: center;
	border-top-left-radius: 8px;
	& h4 {
		margin-left: 12px;
	}
	.office__info-img-container {
		width: 50px;
		height: 50px;
		border-radius: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		box-shadow: 0 5px 5px 0 rgb(0 0 0 / 55%);
	}
	& img {
		width: 40px;
	}
`;

export const OfficeInfoContainer = styled.div`
	width: 250px;
	word-break: break-all;

	.office__info-content {
		display: flex;
	}

	& span {
		margin-left: 12px;
	}
`;

export const LogoContainer = styled.div`
	display: flex;
	position: ${(props) => (props.relative ? "relative" : "absolute")};
	margin-left: ${(props) => (props.relative ? "1rem" : 0)};
	background: transparent;
	top: -12%;

	img {
		height: 5rem;
		width: 5rem;
		border-radius: 9999px;
		background-color: #ffffff;
		box-shadow: 0 5px 5px 0 rgb(0 0 0 / 55%);
		padding: 0.5rem;
	}

	span {
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		right: 0;
		bottom: 0;
		width: 1.5rem;
		height: 1.5rem;
		padding: 0;
		border-radius: 110px;
		background: #1890ff;
		color: #fff;
	}
`;

export const ModuleNameContainer = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	overflow-wrap: break-word;
	h2 {
		padding: 4px;
		background: #1890ff;
		width: 90%;
		color: #fff;
		margin: 0;
		font-size: 24px;
		font-weight: 500;
	}
`;

export const InfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: space-around;
	min-width: 300px;

	div {
		display: flex;
		flex-direction: column;
		padding: 1rem;
		text-align: center;
	}

	span {
		width: 60%;
		display: flex;
		justify-content: space-evenly;
		align-self: center;
		align-items: flex-end;
		margin-bottom: 0.5rem;
		font-weight: 600;
		color: #0050b3;
		font-size: 24px;
		span {
			width: 65%;
			font-size: 1.2rem;
			margin: 0;
		}
	}

	p {
		margin-bottom: 0;
		font-size: 14px;
		font-weight: 500;
	}
`;

export const BotView = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	width: 100%;
	padding: 1.5rem 0;
	text-align: center;
	align-items: center;
	min-width: 280px;
	background: ${({ reservationConfirmed }) =>
		reservationConfirmed === "userCanceled" ? "##FAFAFA" : "#753483"};

	border-top-right-radius: 8px;
	border-bottom-right-radius: 8px;
	color: ${({ reservationConfirmed }) =>
		reservationConfirmed === "userCanceled" ? "#E5E5E5" : "#fff"};
	& button {
		width: 60%;
		height: 32px;
		color: #fff;
		margin: 0;
	}

	h3 {
		font-weight: bold;
		font-size: 1rem;
		line-height: 1.4rem;
		/* color: ${(props) => (props.passed ? "#595959" : "#0050b3")}; */
		color: ${({ reservationConfirmed }) =>
			reservationConfirmed === "userCanceled" ? "#E5E5E5" : "#fff"};
	}

	P {
		font-size: 0.8rem;
		margin: 0;
		color: ${({ reservationConfirmed }) =>
			reservationConfirmed === "userCanceled" ? "#E5E5E5" : "#fff"};
	}

	.info {
		span {
			font-weight: 500;
			font-size: 0.9rem;
			line-height: 1.4rem;
			color: ${({ reservationConfirmed }) =>
				reservationConfirmed === "userCanceled" ? "#E5E5E5" : "#fff"};
		}

		h4 {
			font-weight: 500;
			font-size: 2.3rem;
			line-height: 2.9rem;
			/* color: ${(props) => (props.passed ? "#595959" : "#0050b3")}; */
			color: ${({ reservationConfirmed }) =>
				reservationConfirmed === "userCanceled" ? "#8C8C8C" : "#fff"};
			margin: 0;
			text-decoration: ${({ reservationConfirmed }) =>
				reservationConfirmed === "userCanceled"
					? "line-through"
					: "none"};
		}
	}
	.line__name {
		width: 100%;
		color: ${({ reservationConfirmed }) =>
			reservationConfirmed === "userCanceled" ? "#8C8C8C" : "#fff"};
		font-size: 14px;
		font-weight: 700;
		margin: 0;
	}

	.line__title {
		width: 100%;
		font-weight: 400;
		color: ${({ reservationConfirmed }) =>
			reservationConfirmed === "userCanceled" ? "#8C8C8C" : "#fff"};
	}
`;
export const TitleWrapper = styled.div`
	display: flex;
	div {
		margin-left: 8px;
	}
`;
export const AlertStyled = styled.div`
	width: 90%;
	.ant-alert {
		font-weight: 500;
		align-items: flex-start;
	}
`;

export const AttentionContainer = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	font-family: Montserrat;

	svg {
		width: 100%;
		height: 6rem;
		circle {
			fill: #f4f9ff;
		}
	}

	h1 {
		width: 75%;
		margin: 0 auto 1rem;
		font-size: 2rem;
		font-weight: 500;
		line-height: 2.2rem;
		letter-spacing: 0em;
		color: #0050b3;
	}

	h6 {
		margin-bottom: 1rem;
		font-weight: normal;
		font-size: 1rem;
		line-height: 1.5rem;
		color: #0050b3;
	}

	a {
		font-weight: 600;
		font-size: 1.2rem;
		line-height: 1.5rem;
		text-decoration-line: underline;
		color: #0050b3;
	}
`;

export const StyledGif = styled.img`
	width: 128px;
	height: 96px;
	margin: auto;
`;
